var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full"},[_c('survey-container',{staticClass:"h-full",scopedSlots:_vm._u([{key:"left",fn:function(){return [_c('sample-survey-left')]},proxy:true},{key:"default",fn:function(){return [_c('sample-survey-main')]},proxy:true},{key:"right",fn:function(){return [_c('sample-survey-right')]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }